import { combineReducers } from "redux";
import widgetReducer from "products/widgets/reducer";
import { orderHdListingsReducer } from "products/orderHdListings/reducer";
export const officeProductsReducer = combineReducers({
    widgets: widgetReducer,
    orderHdListings: orderHdListingsReducer
});
